import { useEffect, useState } from "react";

export const useInIframe = () => {
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    const checkIfInIframe = () => {
      try {
        return window !== window.parent;
      } catch (e) {
        return true;
      }
    };

    setIsInIframe(checkIfInIframe());
  }, []);

  return isInIframe;
};
